var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEyeHideActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29403 2.38367C6.5552 2.34505 6.82463 2.32434 7.10213 2.32434C10.3828 2.32434 12.5356 5.21933 13.2588 6.3645C13.3463 6.5031 13.3901 6.57241 13.4146 6.6793C13.433 6.75957 13.433 6.88622 13.4146 6.9665C13.39 7.07338 13.346 7.14314 13.2578 7.28267C13.0651 7.58765 12.7713 8.01626 12.3821 8.48112M3.7115 3.42649C2.32207 4.36903 1.3788 5.67852 0.946085 6.36351C0.858159 6.5027 0.814196 6.57229 0.789689 6.67917C0.771282 6.75945 0.771275 6.88608 0.789672 6.96636C0.814167 7.07324 0.857932 7.14254 0.945461 7.28113C1.66869 8.4263 3.82145 11.3213 7.10213 11.3213C8.42494 11.3213 9.56438 10.8506 10.5007 10.2138M1.31837 1.03906L12.8859 12.6066M5.73888 5.45957C5.39 5.80846 5.17421 6.29044 5.17421 6.82282C5.17421 7.88758 6.03737 8.75073 7.10213 8.75073C7.63451 8.75073 8.11649 8.53495 8.46537 8.18606",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeHideActive);
export default __webpack_public_path__ + "static/media/password-eye-hide-active.36a8dc5205244784492b0d9899e1af19.svg";
export { ForwardRef as ReactComponent };